import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { NotFound } from "./NotFound";
import { PageSkeleton } from "../components/PageSkeleton";
import { apiGet } from "../utils/api";
import { isTenderContent } from "../utils/tenders";
import { TenderDetailView } from "../components/TenderDetailView";
import { ArticleDetailView } from "../components/ArticleDetailView";

export const ArticleDerails: React.FC = () => {
  const { article } = useParams();
  const [item, setItem] = useState<any | null>(undefined as any);

  useEffect(() => {
    if (!article) return;
    setItem(undefined); // reset → affiche le skeleton pendant le chargement
    apiGet(`/contents/slug/${article}`)
      .then((d) => setItem(d.item))
      .catch(() => setItem(null));
  }, [article]);

  if (item === undefined) return <PageSkeleton />;
  if (item === null) return <NotFound />;

  if (isTenderContent(item)) {
    return <TenderDetailView key={article} item={item} />;
  }

  return <ArticleDetailView key={article} item={item} slug={article ?? ""} />;
};
